import * as React from 'react';

import {providers} from '@logilab/cwclientlibjs';

interface EntityTypeListElemProps {
    entityType: providers.EntitySchema;
}

export class EntityTypeListElem extends React.Component<EntityTypeListElemProps> {
    render() {
        return <span>{this.props.entityType.name}</span>;
    }
}
